<template>
  <div id="app">
    <div class="app-content">
      <div class="home-title" v-if="showTitle">
        泰乐德家园智能健康科技（深圳）有限公司
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        router
        v-if="$route.meta.menu"
      >
        <el-menu-item index="/home">首页</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/news">健康资讯</el-menu-item>
        <!-- <el-menu-item index="/mall/home">健康商城</el-menu-item> -->
        <el-menu-item index="/contactUs">联系我们</el-menu-item>
        <el-menu-item style="display: flex; align-items: center">
          <el-input v-model="value" placeholder="请输入关键字" clearable />
          <el-button
            icon="el-icon-search"
            @click="searchFn"
            size="small"
            style="margin: 0 10px"
          />
        </el-menu-item>
      </el-menu>
      <router-view />
      <footer class="site-footer footer-default" v-if="$route.meta.menu">
        <div class="copyright-area">
          <div class="container">
            <div class="copyright-content">
              <div class="row">
                <div
                  class="col-sm-12 site-demo-button"
                  id="layerDemo"
                  style="margin-bottom: 0"
                >
                  <p class="copyright-text">
                    <span id="tiaokuan1" data-method="notice">隐私条款</span> |
                    <span id="tiaokuan2" data-method="notice"
                      >Copyright©2022-2025 泰乐德家园智能健康科技（深圳）有限公司 </span
                    >|
                    <span id="tiaokuan3" data-method="notice"
                      >备案号-<a
                        href="https://beian.miit.gov.cn"
                        target="_blank"
                        >粤ICP备2022076942号</a
                      >
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "/home",
      value: null,
      showTitle:false,
    };
  },
  watch: {
    $route(options) {
      this.setCurrentRoute(options);
    },
  },
  mounted() {
    this.setCurrentRoute();
  },
  methods: {
    setCurrentRoute(options) {
      if(options && ['home','about','news','contactUs','mallHome'].includes(options.name)){
        this.showTitle = true
      }else{
        this.showTitle = false
      }
      this.activeIndex = this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
    },
    searchFn() {
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@assets/style/index.css";
#app{
  width: 1280px;
  margin: 0 auto;
  min-height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  //margin-top: 60px;
}
.app-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .el-menu{
    padding-top: 7px;
  }
  .home-title{
    color: #fff;
    width: 100%;
    text-align: left;
    background: #4874CB;
    padding: 10px 15px;
    margin-top: 7px;
    position: relative;
    box-sizing: border-box;
    &:after{
      content: '';
      position: absolute;
      bottom: -8px;
      height: 1px;
      background: #ccc;
      width: 100%;
      right: 0;
      z-index: 99;
    }
  }
}

</style>
